import { render, staticRenderFns } from "./kreditpage.vue?vue&type=template&id=3405fbac&scoped=true&"
import script from "./kreditpage.vue?vue&type=script&lang=js&"
export * from "./kreditpage.vue?vue&type=script&lang=js&"
import style0 from "./kreditpage.vue?vue&type=style&index=0&id=3405fbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3405fbac",
  null
  
)

export default component.exports